import colors from 'styles/colors';

export type Video = {
  name: string;
  id: number;
  video_host_id: string;
};

interface ThumbnailVideosProps {
  handleClick: (id: number) => void;
  ariaRoleDescription: string;
  ariaLabel: string;
  video: Video;
  isHidden?: boolean;
}

function VideoThumbnail({
  handleClick,
  ariaRoleDescription,
  ariaLabel,
  video,
  isHidden = false
}: ThumbnailVideosProps) {
  return (
    <div
      role="group"
      className="snap-start flex-shrink-0 px-1"
      aria-roledescription={ariaRoleDescription}
      aria-label={ariaLabel}
      aria-hidden={isHidden}
      data-carousel-slide
      // React 18 does not support `inert` as a boolean prop yet
      {...(isHidden ? { inert: '' } : {})}
    >
      <button
        type="button"
        className="group block w-60 text-left cursor-pointer"
        onClick={() => handleClick(video.id)}
      >
        <span className="h-32 flex">
          <img
            className="w-full max-h-full max-w-full rounded group-focus-visible:scale-105 hover:scale-105"
            src={`https://cdnsecakmi.kaltura.com/p/966871/thumbnail/entry_id/${video.video_host_id}/width/300`}
            alt=""
            style={{
              transition: 'all 0.3s ease-out'
            }}
          />
        </span>
        <span
          className="block font-semibold mt-2 break-words"
          style={{ color: `${colors.scaleDarkBlue}` }}
        >
          {video.name}
        </span>
      </button>
    </div>
  );
}

export default VideoThumbnail;
